<app-header></app-header>
<br /><br /><br /><br /><br />

<div>
  <section class="svg-page svg-unauthorized-error util-padding-top-20 util-padding-bottom-10">
    <div class="text-center">
      <div>
        <h1>You don't have permission to view this page. <br>Please contact help desk for more details.</h1>
      </div>
    </div>
  </section>
</div>
<br /><br /><br /><br /><br /><br /><br /><br />
<app-footer></app-footer>